export function getUrlCompliantName(name: string): string {
    return name
        .replaceAll(" -", "-")
        .replaceAll("- ", "-")
        .replaceAll(" ", "-")
        .replaceAll("/", "-")
        .replaceAll("'", "-")
        .replaceAll(".", "-")
        .replaceAll("_", "-")
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll('#', '')
        .replaceAll(',', '');
}
